module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_PL-60a64e1ca3032f01c4ee10286bd8cec1.svg";